export default __webpack_public_path__ + "static/media/icon-search.77ee8062.svg";